<template>
  <div>
    <content-data
    v-if="is_settings"
    :list="list_id"
    editpath="/billing/contracts/list/"
    :disable-import="true"
    :search="search"></content-data>

    <v-btn class="deep-orange"
     fab dark fixed top right style="top: 87px; right: 26px;"
     @click.stop="open_add"><v-icon>add</v-icon></v-btn>

     <v-toolbar :color="$dark() ? 'grey darken-4' : 'white'" fixed dense right style="top: 87px; left: auto; right: 90px; width: 300px;">
        <v-text-field color="deep-orange" v-model="search" ref="search_field" label="Search" prepend-icon="search" hide-details single-line></v-text-field>
    </v-toolbar>
  </div>
</template>

<script>
import ContentData from '../content/Data'
import SettingsModel from '@/models/settings.js';

export default {
  data() {
    return {
      search: ''
    }
  },
  components: {
    ContentData,
  },

  methods: {
    open_add() {
      this.$router.push("/billing/contracts/list/" + this.list_id + "/data/new");
    },
  },

  computed: {
    is_settings() {
      if (this.settings.length > 0) return true;
      return false;
    },
    settings() {
      return SettingsModel.list("billing_config");
    },
    list_id() {
      return this.settings[0].value.contracts_list_id;
    },

  }
}
</script>
